// internal dependencies
import { FILTER_SECTION } from "./filter-elements";

/**
 * Sets the date filter based on the FILTER_SECTION configuration.
 * 
 * @returns date
 */
export const setDateFilter = (): Date => {
  let date = new Date();
  date.setDate(date.getDate() - FILTER_SECTION.dateToSet);
  return date;
};